import { useCallback, useSyncExternalStore } from 'react';
import { YouTubeVideoId } from '../../../../common/src/model.ts';
import { PracticeVideoData } from './youtube_video_player.ts';

// The YouTube channel of each practice video, as its player learns it (GitHub issue #4041), for the video's
// badge. Kept by video id, so a part switch never shows the previous video's channel.

const channelNames = new Map<YouTubeVideoId, string>();
const listeners = new Set<() => void>();

export function notePracticeVideoData({ videoId, channelName }: PracticeVideoData) {
  if (channelNames.get(videoId) === channelName) {
    return;
  }
  channelNames.set(videoId, channelName);
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePracticeVideoChannelName(videoId: YouTubeVideoId | undefined): string | undefined {
  const getSnapshot = useCallback(() => (videoId ? channelNames.get(videoId) : undefined), [videoId]);
  return useSyncExternalStore(subscribe, getSnapshot);
}
